<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :slides-per-group="1"
    :navigation="{
      nextEl: nextEl,
      prevEl: prevEl,
    }"
    class="post-slider"
    @slideChange="onSlideChange"
  >
    <!-- Первый слайд с коллажом -->
    <swiper-slide v-if="postImages.length > 1 && !isModal" class="post-slide">
      <div class="collage-container" :class="`collage-${imagesCount}`">
        <div
          v-for="(img, index) in postImages.slice(0, 4)"
          :key="index"
          class="collage-item"
          :class="`item-${index + 1}`"
        >
          <img
            :src="img.url"
            :alt="`Post image ${index + 1}`"
            loading="lazy"
            class="swiper_img"
          />
          <Bubble
            :trigger="visible && activeIndex === 0"
            :image="
              this.post.metadata?.frames?.[index]?.bubbles_image_url || ''
            "
          />
        </div>
      </div>
    </swiper-slide>

    <!-- Слайды поста -->
    <swiper-slide
      v-for="(image, index) in postImages"
      :key="index"
      class="post-slide"
    >
      <img
        :src="image.url"
        alt="Image"
        class="post-image swiper_img"
        loading="lazy"
      />
      <Bubble
        :trigger="visible && activeIndex === index"
        :image="this.post.metadata?.frames?.[index]?.bubbles_image_url || ''"
      />
    </swiper-slide>

    <!-- Кастомные стрелки с уникальными классами -->
    <div
      @click.stop
      ref="nextEl"
      :class="`swiper-button-next next-${post.id}`"
    ></div>
    <div
      @click.stop
      ref="prevEl"
      :class="`swiper-button-prev prev-${post.id}`"
    ></div>
  </swiper>
</template>

<script>
import Bubble from "@/UI/Bubble.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import SwiperCore from "swiper";
import { Navigation } from "swiper/modules";

SwiperCore.use([Navigation]);

export default {
  name: "PostSwiper",
  components: {
    Swiper,
    SwiperSlide,
    Bubble,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      modules: [Navigation],
      nextEl: null,
      prevEl: null,
      activeIndex: 0,
    };
  },
  methods: {
    onSlideChange(swiper) {
      this.activeIndex = swiper.activeIndex;
    },
  },
  computed: {
    imagesCount() {
      return Math.min(this.postImages.length, 4);
    },
    postImages() {
      const images = [];
      for (let index = 1; index <= 10; index++) {
        const pictureKey = `picture_${index}`;
        if (this.post[pictureKey]?.url) {
          images.push({
            url:
              import.meta.env.VITE_IMG_BASE_URL + this.post[pictureKey].related,
            id: index,
          });
        }
      }
      return images;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.nextEl = this.$refs.nextEl;
      this.prevEl = this.$refs.prevEl;
    });
  },
};
</script>

<style>
.post-slide {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.swiper_img,
.collage-container {
  width: 100%;
  height: 100%;
  display: block;
}

/* Кастомизация стрелок */
.swiper-button-prev,
.swiper-button-next {
  color: #fff !important;
  width: 48px !important;
  height: 48px !important;
  background: rgba(134, 134, 134, 0.2);
  backdrop-filter: blur(5px);
  border-radius: 15px;
  transition: all var(--transition-time) ease;
}

.swiper-button-prev {
  margin-left: 10px !important;
}

.swiper-button-next {
  margin-right: 10px !important;
}

.swiper-button-prev:hover,
.swiper-button-next:hover {
  background: rgba(206, 206, 206, 0.4);
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 16px !important;
  font-weight: 800;
}

.post-slider {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: auto;
  max-height: 100%;
}

.collage-container {
  display: grid;
  gap: 4px;
}

.collage-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: relative;
}

.collage-2 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  object-position: center;
}

.collage-3 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.collage-3 .item-1 {
  grid-column: 1 / 3;
  object-position: center;
  grid-row: 2;
}

.collage-3 .item-2 {
  grid-column: 1;
}

.collage-3 .item-3 {
  grid-column: 2;
}

.collage-4 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.collage-item {
  position: relative;
  overflow: hidden;
  min-height: 0;
}
</style>
